const getExtraHeaders = async () => ({});

export default getExtraHeaders;
